import { useIsOnline } from 'hooks';
import { useNonBlockingImageUpload2 } from './useNonBlockingImageUpload2';
import { useUpdateImage2 } from './useUpdateImage2';

export const useDirectFileUpload = () => {
  const nonBlockingUpload = useNonBlockingImageUpload2();
  const saveImage = useUpdateImage2();
  const isOnline = useIsOnline();

  return async (files: File[], sectionId: string, startingIndex = 0) => {
    return Promise.all(
      files.map(async (file, i) => {
        if (isOnline) {
          nonBlockingUpload(sectionId, startingIndex + i, file);
        } else {
          saveImage(sectionId, startingIndex + i, { file });
        }
      })
    );
  };
};
